function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/UserGroupApi";
import * as UserGroupModalComponent from "./UserGroupModalComponent";
import * as UserGroupMemberModalComponent from "./UserGroupMemberModalComponent";
import { NullNumberToBlank } from "../commons/Utility";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import IntlMessage from '../commons/Intl';
import { UserGroups, Action } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Selected: null,
      UserGroupList: [],
      UserGroupModalMode: UserGroupModalComponent.Mode.None,
      UserGroupMemberModalMode: UserGroupMemberModalComponent.Mode.None,
      SearchText: "",
      CurrentPage: 1,
      DataCount: 0
    };

    _this.GetList(_this.state.CurrentPage);

    return _this;
  }
  /**
   * リスト表示
   */


  _createClass(MainComponent, [{
    key: "GetList",
    value: function GetList(pageNum) {
      var _this2 = this;

      Api.Query(this.state.SearchText, (pageNum - 1) * this.props.pageSize + 1, this.props.pageSize, function (data) {
        _this2.setState({
          Selected: null,
          UserGroupList: data.UserGroupList,
          DataCount: data.Count
        });
      });
    }
    /**
     * 前ページ表示
     */

  }, {
    key: "previousPage",
    value: function previousPage() {
      var page = 0;

      if (this.state.CurrentPage <= 1) {
        page = 1;
      } else {
        page = this.state.CurrentPage - 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 次ページ表示
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      var page = 0;
      var maxPage = Math.ceil(this.state.DataCount / this.props.pageSize);

      if (maxPage == 0) {
        page = 1;
      } else if (this.state.CurrentPage >= maxPage) {
        page = maxPage;
      } else {
        page = this.state.CurrentPage + 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * ユーザーグループモーダルを追加で起動します。
     */

  }, {
    key: "openAddUserGroupModal",
    value: function openAddUserGroupModal() {
      this.setState({
        UserGroupModalMode: UserGroupModalComponent.Mode.Add
      });
    }
    /**
     * ユーザーグループモーダルを編集で起動します。
     */

  }, {
    key: "openModifyUserGroupModal",
    value: function openModifyUserGroupModal(m) {
      this.setState({
        UserGroupModalMode: UserGroupModalComponent.Mode.Modify,
        Selected: {
          GroupId: m.GroupId,
          GroupName: m.GroupName,
          OrganizationId: m.OrganizationId,
          NumOfUser: m.NumOfUser,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * ユーザーグループを登録します。
     *
     * @param GroupName グループ名
     * @param updateDateTime 更新日時
     */

  }, {
    key: "entryGroupModal",
    value: function entryGroupModal(GroupName) {
      var _this3 = this;

      Api.AddGroup(GroupName, function (data) {
        _this3.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this3.GetList(_this3.state.CurrentPage);
        }
      });
    }
    /**
     * ユーザーグループを更新します。
     *
     * @param GroupId グループＩＤ
     * @param OrganizationName グループ名
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyGroupModal",
    value: function modifyGroupModal(GroupId, GroupName, OrganizationId, updateDateTime) {
      var _this4 = this;

      Api.ModifyGroup(GroupId, GroupName, OrganizationId, updateDateTime, function (data) {
        _this4.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this4.GetList(_this4.state.CurrentPage);
        }
      });
    }
    /**
     * ユーザーグループを削除します。
     *
     * @param GroupId グループＩＤ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteGroupModal",
    value: function deleteGroupModal(GroupId, updateDateTime) {
      var _this5 = this;

      Api.DeleteGroup(GroupId, updateDateTime, function (data) {
        _this5.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this5.GetList(_this5.state.CurrentPage);
        }
      });
    }
    /**
     * 組織モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenGroupModal",
    value: function hiddenGroupModal() {
      this.setState({
        UserGroupModalMode: UserGroupModalComponent.Mode.None
      });
    }
    /**
     * ユーザーグループメンバーモーダルを編集で起動します。
     */

  }, {
    key: "openModifyUserGroupMemberModal",
    value: function openModifyUserGroupMemberModal(m) {
      this.setState({
        UserGroupMemberModalMode: UserGroupMemberModalComponent.Mode.Modify,
        Selected: {
          GroupId: m.GroupId,
          GroupName: m.GroupName,
          OrganizationId: m.OrganizationId,
          NumOfUser: m.NumOfUser,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * ユーザーグループメンバーを更新します。
     *
     * @param sessionId 会議ID
     * @param targetUserIdList 対象ユーザーＩＤリスト
     * @param targetGroupIdList 対象グループＩＤリスト
     */

  }, {
    key: "modifyMemberModal",
    value: function modifyMemberModal(groupId, targetUserIdList, updateDateTime) {
      var _this6 = this;

      Api.ModifyMember(groupId, targetUserIdList, updateDateTime, function (data) {
        _this6.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this6.GetList(_this6.state.CurrentPage);
        }
      });
    }
    /**
     * 組織モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenMemberModal",
    value: function hiddenMemberModal() {
      this.setState({
        UserGroupMemberModalMode: UserGroupMemberModalComponent.Mode.None
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        width: "60",
        height: "60",
        src: "/assets/img/usergroup_icon.svg"
      }), /*#__PURE__*/React.createElement("h2", null, intl.format(UserGroups.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddUserGroupModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add usergroup"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-middle"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.UserGroupList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: x.GroupId
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-1"
        }, (_this7.state.CurrentPage - 1) * _this7.props.pageSize + _i + 1), /*#__PURE__*/React.createElement("div", {
          className: "col-6",
          onClick: _this7.openModifyUserGroupModal.bind(_this7, x)
        }, x.GroupName), /*#__PURE__*/React.createElement("div", {
          className: "col-5 text-right"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-primary thumbnail-btn",
          onClick: _this7.openModifyUserGroupMemberModal.bind(_this7, x),
          tabIndex: -1
        }, intl.format(Action.MemberSelection)))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1 offset-10 text-right"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddUserGroupModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add usergroup"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))))), this.state.UserGroupModalMode != UserGroupModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserGroupModalComponent["default"], {
        mode: this.state.UserGroupModalMode,
        groupId: NullNumberToBlank(this.state.Selected ? this.state.Selected.GroupId : null),
        groupName: this.state.Selected ? this.state.Selected.GroupName : "",
        organizationId: NullNumberToBlank(this.state.Selected ? this.state.Selected.OrganizationId : null),
        updateDateTime: this.state.Selected ? this.state.Selected.UpdateDateTime : "",
        onEntry: this.entryGroupModal.bind(this),
        onModify: this.modifyGroupModal.bind(this),
        onDelete: this.deleteGroupModal.bind(this),
        onHidden: this.hiddenGroupModal.bind(this)
      }), this.state.UserGroupMemberModalMode != UserGroupMemberModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserGroupMemberModalComponent["default"], {
        mode: this.state.UserGroupMemberModalMode,
        groupId: NullNumberToBlank(this.state.Selected ? this.state.Selected.GroupId : null),
        groupName: this.state.Selected ? this.state.Selected.GroupName : "",
        updateDateTime: this.state.Selected ? this.state.Selected.UpdateDateTime : "",
        onModify: this.modifyMemberModal.bind(this),
        onHidden: this.hiddenMemberModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 */


export default function (el, common, pageSize) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    pageSize: pageSize
  }), el);
}